<script setup lang="ts">
import { ref, watch } from 'vue';
import { UiDialog, UiTextarea } from '@shopexperts/shared';

defineProps<{
  isLoading?: boolean;
}>();

const model = defineModel<boolean>({ default: false });

const emit = defineEmits<{
  confirm: [notes?: string];
  cancel: [];
}>();

const moderationNotes = ref('');

watch(model, (isOpen) => {
  if (!isOpen) {
    moderationNotes.value = '';
    emit('cancel');
  }
});

const handleConfirm = () => {
  emit('confirm', moderationNotes.value);
};

const handleCancel = () => {
  model.value = false;
};
</script>

<template>
  <UiDialog
    v-model="model"
    title="Decline Review"
    text="Are you sure you want to decline this review? This action will remove it from the pending list."
    primary-action-label="Decline Review"
    secondary-action-label="Cancel"
    @primary-action="handleConfirm"
    @secondary-action="handleCancel"
  >
    <UiTextarea
      v-model="moderationNotes"
      label="Reason for Decline (Optional)"
      placeholder="Enter reason for declining..."
      :rows="4"
      :disabled="isLoading"
    />
  </UiDialog>
</template>

